import axios from "axios";
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL;
const api_token = localStorage.getItem('authUser');

//* SEND PHONE NUMBER -
export const sendPhoneAPI = async (payload) => {
  console.log(payload)
  const headers = {
    "Content-Type": "application/json",
    "Accept": "*",
  };
  return await axios.post(`${apiBaseUrl}/send-otp`, payload.payload, {
    headers,
  });
};

//VERIFY OTP
export const verifyOTPAPI = async (payload) => {
  console.log(payload)
  const headers = {
    "Content-Type": "application/json",
    "Accept": "*",
  };
   return await axios.post(`${apiBaseUrl}/verify-sms-otp`, payload.payload, {
     headers,
   });
};



export const sendForgetPassMobnoAPI = async (payload) => {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "*",
  };
  return await axios.post(`${apiBaseUrl}/ForgotPasswordOTP`, payload.payload, {
    headers,
  });
};




export const ForgetPasswordAPI = async (payload) => {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "*",
  };
  return await axios.post(`${apiBaseUrl}/change-password`, payload.payload, {
    headers,
  });
};



export const ChangeProfilePasswordAPI = async (payload) => {
  try {
  
    
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/reset-password`, 
      payload.payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}

